import { ApolloProvider } from "@apollo/client";
import React from "react";
import { RouterProvider } from "react-router-dom";

import { AuthApp } from "src/authentication/AuthApp.tsx";
import { ErrorHandlingProvider } from "src/errors/ErrorHandlingProvider.tsx";
import { createApolloClient } from "src/graphql/anti-fraud/apolloClient.ts";
import { emitError } from "src/hooks/useEvents.ts";
import { useT } from "src/internationalization";
import { InternationalizationProvider } from "src/internationalization/InternationalizationProvider.tsx";
import { LocaleProvider } from "src/internationalization/locale/LocaleProvider.tsx";
import { CurrentUserProvider } from "src/providers/CurrentUserProvider";
import { ThemeProvider } from "src/theme";

import { CaseTypesProvider } from "./providers/CaseTypesProvider";
import { useAppRouter } from "./routes/routes";
import "./styles/tailwind.css";
import "@flaminem/ui-components/dist/style.css";
import "./styles/global.css";

const apolloClient = createApolloClient(emitError);

const App: React.FC = () => {
  const t = useT();
  const appRouter = useAppRouter();

  return (
    <React.StrictMode>
      <ThemeProvider>
        <ApolloProvider client={apolloClient}>
          <LocaleProvider>
            <InternationalizationProvider>
              <AuthApp>
                <ErrorHandlingProvider>
                  <CurrentUserProvider>
                    <CaseTypesProvider>
                      <RouterProvider
                        router={appRouter}
                        fallbackElement={<p>{t("app.loading")}</p>}
                      />
                    </CaseTypesProvider>
                  </CurrentUserProvider>
                </ErrorHandlingProvider>
              </AuthApp>
            </InternationalizationProvider>
          </LocaleProvider>
        </ApolloProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
};

export default App;
